// @ts-nocheck
import React from 'react';
import { useGetAttachmentQuery } from 'hooks/useGetAttachment';
import { Box } from 'components/base';
import { CircularProgress } from 'components/atoms';
import { ImageIcon } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constantSvg';
import { useAttachmentStyles } from '../style';
import { imageFormats } from '../constants';
import ImageActions from './ImageActions';

const ImageItem = ({ photo, setImageAttach, imageAttach, handleDirty }) => {
  const classes = useAttachmentStyles();
  const { data: attachmentData, isLoading: isLoadingAttachment } =
    useGetAttachmentQuery(photo?.id);

  if (isLoadingAttachment) {
    return (
      <CircularProgress key={photo?.id} size={20} sx={{ marginLeft: '10px' }} />
    );
  }

  return (
    <Box key={photo?.id} className={classes.attachmentsContainer}>
      <Box>
        <Box className={classes.attachmentIcon}>
          <ImageIcon />
        </Box>
        <img
          src={attachmentData[photo?.id]?.file}
          alt=""
          className={classes.attachment}
        />
        <ImageActions
          photo={attachmentData[photo?.id]}
          setImageAttach={setImageAttach}
          imageAttach={imageAttach}
          classes={classes}
          handleDirty={handleDirty}
        />
      </Box>
    </Box>
  );
};

export const ImageAttachment = ({
  imageAttach,
  setImageAttach,
  handleDirty,
}) => (
  <>
    {imageAttach
      ?.filter((photo) =>
        imageFormats.includes(photo?.name?.split('.').pop()?.toLowerCase()),
      )
      .map((photo) => (
        <ImageItem
          key={photo?.id}
          photo={photo}
          setImageAttach={setImageAttach}
          imageAttach={imageAttach}
          handleDirty={handleDirty}
        />
      ))}
  </>
);
